export default "__VITE_ASSET__4927c9d2__"